import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChart = ({ chartData }) => {

    const [chartLabels, setChartLabels] = useState();
    useEffect(() => {
        // Generate the last 7 dates
        if (!chartData.labels) {
            const last7Days = Array.from({ length: 7 }, (_, i) => {
                const date = new Date();
                date.setDate(date.getDate() - i);
                const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
                const formattedDate = date.toISOString().split('T')[0];
                return [`${formattedDate}`, `${dayName}`];
            }).reverse();
            setChartLabels(last7Days);
        } else {
            setChartLabels(chartData.labels);
        }
    }, []);

    const formatDate = (date) => {
        const [year, month, day] = date.split("-");
        return `${month}-${day}-${year}`;
    }

    // Chart data
    const data = {
        labels: chartLabels,
        datasets: chartData.datasets
    };

    // Chart options
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                align: 'end',
            },
            title: {
                display: true,
                text: chartData.chartTitle,
                color: '#484a4a'
            },
            datalabels: {
                display: false
            }
        },
        scales: {
            x: {
                grid: {
                    display: true, // Remove grid lines on the X-axis
                },
                ticks: {
                    callback: function (value, index, ticks) {
                        if (data.labels.length > 30) {
                            if (index % 15 === 0) {
                                return formatDate(data.labels[index]);
                            }
                            return '';
                        } else if (data.labels.length > 7) {
                            if (index % 5 === 0) {
                                return formatDate(data.labels[index]);
                            }
                            return '';
                        } else {
                            return formatDate(data.labels[index]);
                        }
                    },
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
            },
            y: {
                grid: {
                    display: true, // Remove grid lines on the Y-axis
                },
                title: {
                    display: true,
                    text: chartData.yAxisLabel, // Y-axis label
                    color: '#484a4a',
                    font: {
                        size: 14,
                        weight: 'bold'
                    },
                },
                beginAtZero: true,
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default LineChart;
